import * as ROUTES from '../routes';

const Navigations = [
    {
        title: "Dashboard",
        icon: "mdi-speedometer",
        to: ROUTES.DASHBOARD,
        mini: "",
        permissions: []
    },
]

export default Navigations